module.exports = __webpack_public_path__ + "img/stage_vehicle_scheduling.9bccd8b9.svg";